export const reloadPage = () => window.location.reload()

export const getCurrentPageUrl = () => {
  return new URL(window.location.href)
}

// Appends a path to the URL by making sure the query params (if any) remain
// at the end of the URL.
//
// Example A: Current URL is "https://foo/current-page-url"
//   -> safeAppendToUrl("/accept") => "https://foo/current-page-url/accept"
//
// Example B: Current URL is "https://foo/current-page-url?foo=bar"
//   -> safeAppendToUrl("/accept") => "https://foo/current-page-url/accept?foo=bar"
export const safeAppendToUrl = (pathToAppend) => {
  let currentUrl = getCurrentPageUrl()

  currentUrl.pathname = removeTrailingSlash(currentUrl.pathname) + pathToAppend

  return currentUrl.toString()
}

const removeTrailingSlash = (url) => {
  return url.replace(/\/$/, "")
}

export const go = (href) => {
  window.location.href = href
}

export const reload = () => {
  window.location.reload()
}

export const getSearchParam = (key) => {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get(key)
}

export const getLastPathParam = () => {
  const pathParts = window.location.pathname.split("/")
  return pathParts[pathParts.length - 1]
}

export const origin = () => {
  return new URL(window.location.origin)
}

/**
 * Captures page navigation for both Single Page Apps and Multi Page Apps
 */
export const onPageNavigation = (callback) => {
  if (typeof MutationObserver !== "function") {
    return
  }

  let previousUrl = ""
  const observer = new MutationObserver(function () {
    if (location.href !== previousUrl) {
      previousUrl = location.href
      callback()
    }
  })

  observer.observe(document, { subtree: true, childList: true })
  return observer
}
